<template>
    <div id="contentModal">
        <Dialog  v-model:visible="visible" modal :blockScroll="true" :dismissableMask="true" :draggable="false" :header="header" :style="{width:'90vw',maxWidth:'690px'}" >
            <div v-html="content"></div>
        </Dialog>
    </div>
</template>
<script>
import Dialog from 'primevue/dialog';
import CustomEventsNames from '../customEventsNames';

export default {
    name: "contentModal",
    components: {
        Dialog
    },
    data() {
        return {
            visible:false,
            header:"",
            content:""
        };
    },
    mounted() {
        const vm = this;
        this.$el.addEventListener(CustomEventsNames.openContentModal, e => {
            vm.header = e.detail.header;
            vm.content = e.detail.content;
            vm.visible = true;
        });
    },
    methods: {
    }
};
</script>
